import { Info } from "lucide-react";

import { Button } from "@acme/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@acme/ui/tooltip";

import { useStudioStore } from "../_hooks/use-studio-store";

export function RuleErrors() {
  const errors = useStudioStore((state) => state.ruleErrors);
  if (!errors) return null;

  const errorCount = Math.max(errors.match(/Error/g)?.length ?? 0, 1);
  const errorLabel = `${errorCount} ${errorCount === 1 ? "error" : "errors"} found`;

  return (
    <TooltipProvider delayDuration={5}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            className="data-[state=delayed-open]:bg-muted data-[state=delayed-open]:text-muted-foreground gap-1 rounded-none text-xs text-red-500"
          >
            <Info className="size-4" />
            <span>{errorLabel}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent className="w-sm">
          <pre className="block break-words whitespace-normal">{errors}</pre>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
